import { useEffect } from 'react';

/**
 * Calls handler when Escape is pressed while `active` is true.
 */
export function useEscapeKey(active, handler) {
    useEffect(() => {
        if (!active || typeof handler !== 'function') return undefined;

        const onKeyDown = (event) => {
            if (event.key === 'Escape') {
                event.preventDefault();
                handler(event);
            }
        };

        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, [active, handler]);
}
